import UserCellSkeleton from '../UserCell/Skeleton';

interface CourseUserCellSkeletonProps {
  className?: string;
}

const CourseUserCellSkeleton = ({ className }: CourseUserCellSkeletonProps) => {
  return <UserCellSkeleton className={className} />;
};

export default CourseUserCellSkeleton;
